import { render } from "./ContributionDetails.vue?vue&type=template&id=ee9871e2&ts=true"
import script from "./ContributionDetails.vue?vue&type=script&lang=ts"
export * from "./ContributionDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__